export const mobileNumberRegex =
  /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const isoDateTimeStringRegex =
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
export const SOCIAL_CATEGORY = {
  general: "0",
  sc: "1",
  st: "2",
  obc: "3",
};

export const SOCIAL_CATEGORY_NAMES = {
  [SOCIAL_CATEGORY.general]: "General",
  [SOCIAL_CATEGORY.sc]: "SC",
  [SOCIAL_CATEGORY.st]: "ST",
  [SOCIAL_CATEGORY.obc]: "OBC",
};

export const QUALIFICATION_NAME = {
  q_10: "10th Std",
  q_12: "12th Std",
  q_graduate: "Bachelor's",
  q_post_graduate: "Master's",
};

export const QUALIFICATION_CODE = {
  q_10: "3",
  q_12: "5",
  q_graduate: "6",
  q_post_graduate: "7",
};

export const IDENTITY_PROOF_CODE = {
  driving_license: "driving_license",
  employers_card: "employers_card",
  pan: "pan",
  passport: "passport",
};

export const IDENTITY_PROOF_NAME = {
  [IDENTITY_PROOF_CODE.driving_license]: "Driving License",
  [IDENTITY_PROOF_CODE.employers_card]: "Employer's Card",
  [IDENTITY_PROOF_CODE.pan]: "PAN Card",
  [IDENTITY_PROOF_CODE.passport]: "Passport",
};
